module.exports = __webpack_public_path__ + "static/media/icon_nutrition.01d97544.svg";